// extracted by mini-css-extract-plugin
module.exports = {"container":"LineThrough-module__container___3Ofm5","divider":"LineThrough-module__divider___3CIE3","text":"LineThrough-module__text___2K3PQ"};